import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { chatwootService } from '../../services/chatwootService';

export const useGetChatwootIdentity = ({ inbox, enabled }) => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.chatwoot.identity, inbox],
    enabled: !!enabled,
    queryFn: () =>
      chatwootService.getIdentity({ inbox }).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};